import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-responsive-modal/styles.css';
import './styles/index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { routes } from './routes';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import AlertStateProvider from './apps/state/AlertState';
import MenuStateProvider from './apps/state/MenuState';
import { install } from "resize-observer";


if (!window.ResizeObserver) install();
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <MenuStateProvider>
        <AlertStateProvider>
          <RouterProvider router={routes} />
          <ReactQueryDevtools initialIsOpen={false} />
        </AlertStateProvider>
      </MenuStateProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
